import React, { memo } from "react";
import { ZoneSelectorDropdownStyled, ZoneSelectorItemStyled } from "./styles";

// ============================================================================
// Types
// ============================================================================

export interface ZoneSelectorDropdownProps {
  semanticMaps: Array<SemanticMap>;
  onSelect: (semanticMapId: string) => void;
}

// ============================================================================
// Component
// ============================================================================

export const ZoneSelectorDropdown = memo<ZoneSelectorDropdownProps>(
  ({ semanticMaps, onSelect }) => {
    return (
      <ZoneSelectorDropdownStyled>
        {semanticMaps.map((semanticMap) => (
          <ZoneSelectorItemStyled
            key={semanticMap.id}
            onClick={() => onSelect(semanticMap.id)}
          >
            {semanticMap.name}
          </ZoneSelectorItemStyled>
        ))}
      </ZoneSelectorDropdownStyled>
    );
  }
);

ZoneSelectorDropdown.displayName = "ZoneSelectorDropdown";
